import { styled } from "@mui/system";

export const ValidationMessage = styled("span")`
  display: block;
  margin-top: 5px;
  font-size: 1.4rem;
  color: ${({ theme }) => theme.palette.error.main};
`;
